import { ProductMenuApp } from '~/components/PageLayout/types';
import { pilotV3 } from '~/services/serviceInstances';

interface UpcApp {
  appId: string;
  name: string;
  redirectUri: string;
}

const mapAppOptions = (apps: UpcApp[]) =>
  apps.map((app) => ({
    href: app.redirectUri,
    id: app.appId,
    label: app.name,
  }));

export const getWorkdayUpcApps = async (): Promise<ProductMenuApp[]> => {
  const response: UpcApp[] = await pilotV3.get('/workday/upc/apps');
  return mapAppOptions(response.filter((app) => app.redirectUri)); // only return apps with a redirect URI
};
